import React, { useContext, useEffect } from "react";
// Soft UI Dashboard PRO React example components

import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Overview page components
import Header from "./components/Header";
import ProjectRequirement from "./components/ProjectRequirement";
import ServicesWeOffer from "./components/ServicesWeOffer";
import OurSpecialties from "./components/OurSpecialties";
import AboutOurCompany from "./components/AboutOurCompany";
import Gallery from "./components/Gallery";
import ReviewsBoard from "./components/ReviewsBoard";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

const Profile = () => {
  const {
    store,
    tags = [],
    retriveStore,
    updateStore,
    listStoreTags,
    addStoreTag,
  } = useContext(StoreContext);

  const account = useContext(AccountContext);

  return (
    <div>
      <Header store={store} updateStore={updateStore} editable={false} />

      <SuiBox my={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={7.5} lg={7.5}>
            <AboutOurCompany
              store={store}
              tags={tags}
              listStoreTags={listStoreTags}
              updateStore={updateStore}
              addStoreTag={addStoreTag}
              editable={false}
              account={account}
            />
            <Grid container spacing={3} mt={1}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <ProjectRequirement store={store} updateStore={updateStore} editable={false} />
              </Grid>
              <Grid item xs={12} sm={12} md={7} lg={7}>
                <OurSpecialties store={store} updateStore={updateStore} editable={false} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={4.5} lg={4.5}>
            <ServicesWeOffer store={store} updateStore={updateStore} editable={false} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Gallery store={store} updateStore={updateStore} editable={false}></Gallery>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ReviewsBoard store={store}></ReviewsBoard>
          </Grid>
        </Grid>
      </SuiBox>
    </div>
  );
};

export default Profile;
